import Layout from '../components/layout/Layout'
import PrivacyPolicyContent from '../content/landing/en/sections/PrivacyPolicyV1.mdx'

function PrivacyPolicyPage() {
  return (
    <Layout>
      <div style={{ marginTop: '2rem', marginBottom: '4rem' }}>
        <PrivacyPolicyContent />
      </div>
    </Layout>
  )
}

export default PrivacyPolicyPage
